import { render, staticRenderFns } from "./BaseTableHeader.vue?vue&type=template&id=6891c3c0&scoped=true&"
import script from "./BaseTableHeader.vue?vue&type=script&lang=js&"
export * from "./BaseTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableHeader.vue?vue&type=style&index=0&id=6891c3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6891c3c0",
  null
  
)

export default component.exports